export default  {
    name: "Congestion",
    mapLayerIcon: "/mapicons/congestion.png",
    defaultOn: true,
    showOnMap: true,
    wmsMapLayer: "cdot:congestionsegments",
    wmsPublish: "tasWebapp.congestion.segments.publishing"
}
